<template functional>
  <span class="d-flex flex-column adresse">
    <span :class="$options.textColor(props, 'ligne1')">{{
      props.adresse.ligne1
    }}</span>
    <span
      v-if="props.adresse.ligne2"
      :class="$options.textColor(props, 'ligne2')"
      >{{ props.adresse.ligne2 }}</span
    >
    <span
      v-if="props.adresse.ligne3"
      :class="$options.textColor(props, 'ligne3')"
      >{{ props.adresse.ligne3 }}</span
    >
    <span v-if="props.adresse.codePostal || props.adresse.ville">
      <span
        v-if="props.adresse.codePostal"
        :class="$options.textColor(props, 'codePostal')"
        >{{ props.adresse.codePostal }}</span
      >
      <template v-else>
        <span
          v-if="props.adresse.ville"
          :class="$options.textColor(props, 'ville')"
          >{{ props.adresse.ville.codePostal }}</span
        >
      </template>
      &nbsp;
      <span
        v-if="props.adresse.ville"
        :class="$options.textColor(props, 'ville')"
        >{{ props.adresse.ville.libelle }}</span
      >
      <span v-else :class="$options.textColor(props, 'localite')">{{
        props.adresse.localite
      }}</span>
    </span>
    <span
      v-if="props.adresse.cedex"
      :class="$options.textColor(props, 'cedex')"
      >{{ props.adresse.cedex }}</span
    >
    <span
      v-if="props.adresse.pays"
      :class="$options.textColor(props, 'pays')"
      >{{ props.adresse.pays.libelle }}</span
    >
  </span>
</template>

<script>
function color(props, path) {
  if (!props.analyseDiff) {
    return null;
  }

  const c = props.analyseDiff.color[props.itemPath];
  return (
    c || (path ? props.analyseDiff.color[props.itemPath + '.' + path] : null)
  );
}

function textColor(props, path) {
  const c = color(props, path);
  if (c) {
    return `${c}--text`;
  } else {
    return null;
  }
}

export default {
  functional: true,
  props: {
    itemPath: {
      type: String,
      default: '',
    },
    adresse: {
      type: Object,
    },
    analyseDiff: {
      type: Object,
    },
  },
  textColor,
};
</script>

<style scoped>
span.adresse span {
  margin-top: 2px;
}
</style>
